import { useRef, useState } from "react";
import { Link } from "react-router-dom";

import pubVideo from "../assets/pub-cpu.mp4";

export default function PromoVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !video.muted;
    setMuted(video.muted);
    if (!video.muted) {
      // Certains navigateurs mettent l'audio en pause au unmute si le volume est à 0
      video.volume = 1;
      video.play().catch(() => {});
    }
  };

  return (
    <section className="section pt-0">
      <div className="container">
        <div className="row align-items-center gy-4 mb-4">
          <div className="col" data-aos="fade-up">
            <span className="eyebrow">En vidéo</span>
            <h2 className="fw-900 mt-3 mb-0">Découvrez CPUc en images</h2>
          </div>
        </div>

        <div className="video-wrapper section-img" data-aos="zoom-in">
          <video
            ref={videoRef}
            src={pubVideo}
            autoPlay
            muted={muted}
            loop
            playsInline
            controls
            style={{
              width: "100%",
              display: "block",
              maxHeight: "70vh",
              background: "#000",
            }}
          >
            Votre navigateur ne supporte pas la lecture vidéo.
          </video>

          <button
            type="button"
            onClick={toggleSound}
            className="sound-toggle btn rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2"
          >
            <i
              className={`bi ${muted ? "bi-volume-mute-fill" : "bi-volume-up-fill"}`}
            ></i>
            {muted ? "Activer le son" : "Couper le son"}
          </button>
        </div>
      </div>
    </section>
  );
}
